import { Card, Col, Row } from "react-bootstrap";
import Subscription from "components/settings/Subscription";
import kairosLogo from "../../../assets/img/logos/KairosIQ_logo.png";

const SubscriptionSettings = () => {
  return (
    <div style={{ minHeight: '100vh', marginTop: '-2rem' }}>
      <Row className="h-100 g-0">
        <Col xs={12} xl={12} xxl={10} className="mx-auto" style={{ marginTop: 0 }}>
          {/* AI-Enhanced Header */}
          <div 
            className="px-4"
            style={{
              background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
              border: '1px solid rgba(0, 212, 255, 0.2)',
              backdropFilter: 'blur(15px)',
              margin: '0',
              position: 'relative',
              overflow: 'hidden',
              padding: '1rem',
              marginBottom: '2rem',
              borderRadius: '0 0 16px 16px'
            }}
          >
            {/* Neural Network Background Effect */}
            <div 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300d4ff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                opacity: 0.3
              }}
            />
            
            <Row className="align-items-center position-relative g-0">
              <Col xl={8}>
                <div className="d-flex align-items-center header-content-flex-wrapper">
                  {/* AI Icon with Glow Effect */}
                  <div 
                    className="d-flex align-items-center justify-content-center me-4 logo-container-responsive"
                    style={{ 
                      width: "48px", 
                      height: "48px"
                    }}
                  >
                    <img 
                      src={kairosLogo} 
                      alt="Site Logo" 
                      style={{ 
                        width: "100%", 
                        height: "100%", 
                        objectFit: "contain" 
                      }} 
                    />
                  </div>
                  
                  <div className="text-content-container-responsive">
                    <h1 
                      className="mb-2 profile-title-responsive" 
                      style={{ 
                        color: '#1f2937',
                        fontSize: '1.75rem',
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #1f2937 0%, #374151 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                      }}
                    >
                      AI Subscription Management
                    </h1>
                    <p 
                      className="mb-0 profile-subtitle-responsive" 
                      style={{ 
                        fontSize: '1.1rem',
                        color: '#6b7280',
                        textShadow: '0 0 10px rgba(0, 212, 255, 0.2)'
                      }}
                    >
                      Neural network-powered subscription optimization and billing insights
                    </p>
                  </div>
                </div>
              </Col>
              
              <Col xl={4} className="text-end status-indicator-col-responsive">
                {/* AI Status Indicator */}
                <div 
                  className="d-inline-flex align-items-center status-indicator-div-responsive"
                  style={{
                    background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.25) 0%, rgba(5, 150, 105, 0.25) 100%)',
                    padding: '12px 24px',
                    borderRadius: '16px',
                    border: '1px solid rgba(16, 185, 129, 0.5)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 0 15px rgba(16, 185, 129, 0.3)'
                  }}
                >
                  <div 
                    className="rounded-circle me-3"
                    style={{
                      width: '12px',
                      height: '12px',
                      background: '#10b981',
                      animation: 'pulse 2s infinite',
                      boxShadow: '0 0 10px rgba(16, 185, 129, 0.8)'
                    }}
                  />
                  <span 
                    className="fw-bold text-success"
                    style={{ 
                      fontSize: '14px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      textShadow: '0 0 5px rgba(16, 185, 129, 0.5)',
                      color: '#047857' /* Darker green color for better contrast */
                    }}
                  >
                    BILLING ACTIVE
                  </span>
                </div>
              </Col>
            </Row>
          </div>

          {/* Main Settings Content with AI Enhancement */}
          <Card 
            className="border-0 shadow-lg"
            style={{
              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(0, 212, 255, 0.1) !important',
              borderRadius: '20px',
              boxShadow: '0 20px 60px rgba(0, 212, 255, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.1) inset !important',
              overflow: 'hidden'
            }}
          >
            <Card.Body className="p-0">
              <Subscription />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* AI Animation Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes pulse {
            0%, 100% { 
              opacity: 1; 
              transform: scale(1); 
            }
            50% { 
              opacity: 0.8; 
              transform: scale(1.05); 
            }
          }
          
          @keyframes glow {
            from {
              filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.8));
            }
            to {
              filter: drop-shadow(0 0 16px rgba(255, 255, 255, 1)) drop-shadow(0 0 24px rgba(0, 212, 255, 0.5));
            }
          }
          
          .ai-hover-lift:hover {
            transform: translateY(-4px);
            transition: all 0.3s ease;
            box-shadow: 0 12px 40px rgba(0, 212, 255, 0.2);
          }

          @media (max-width: 500px) {
            .header-content-flex-wrapper {
              flex-direction: column;
              align-items: flex-start !important;
            }
            .logo-container-responsive {
              width: 100% !important;
              justify-content: center !important; /* Center logo image */
              margin-right: 0 !important; /* Remove right margin when stacked */
              margin-bottom: 0.75rem; /* Space below logo */
            }
            .text-content-container-responsive {
              width: 100%;
            }
            .profile-title-responsive {
              font-size: 1.2rem !important;
              text-align: center;
            }
            .profile-subtitle-responsive {
              text-align: center;
            }
            .status-indicator-col-responsive {
              width: 100%;
              text-align: center !important; /* Center the inline-flex div */
            }
            .status-indicator-div-responsive {
              margin-top: 16px;
            }
          }
        `
      }} />
    </div>
  );
};

export default SubscriptionSettings;
